const mutations = {
  getCorpPartnerLists: (state, corp_partner_list) => {
    state.corp_partner_list = corp_partner_list;
  },
  getCorpPartnerList: (state, corp_partner_list_id) => {
    state.corp_partner_list_id = corp_partner_list_id;
  },
  postCorpPartnerList: (state, new_corp_partner_list) => {
    state.corp_partner_list.push(new_corp_partner_list);
  },
  putCorpPartnerList: (state, payload) => {
    state.corp_partner_list = state.corp_partner_list.map((corp_partner_list) => {
      if (corp_partner_list.corp_partner_list_id === payload.id) {
        return Object.assign({}, corp_partner_list, payload.corp_partner_listData);
      }
      return corp_partner_list;
    });
  },
  delCorpPartnerList(state, id) {
    const index = state.corp_partner_list.findIndex(corp_partner_list => corp_partner_list.corp_partner_list_id == id);
    state.corp_partner_list.splice(index, 1);
  },
};

export default mutations;
